import {
  Directive,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
} from '@angular/core';

export type SortDirection = 'asc' | 'desc' | '';
const rotate: { [key: string]: SortDirection } = {
  asc: 'desc',
  desc: '',
  '': 'asc',
};

export interface SortEvent {
  column: string;
  direction: SortDirection;
}

@Directive({
  selector: 'th[appSortable]',
})
export class SortableHeaderDirective {
  @Input() appSortable: string = '';
  @Input() direction: SortDirection = '';
  @Output() sort: EventEmitter<SortEvent> = new EventEmitter();

  constructor() {}

  @HostBinding('class.asc')
  get ascClass() {
    return this.direction === 'asc';
  }

  @HostBinding('class.desc')
  get descClass() {
    return this.direction === 'desc';
  }

  @HostListener('click', ['$event'])
  onClick(e: any) {
    this.rotate();
  }

  rotate() {
    this.direction = rotate[this.direction];
    this.sort.emit({ column: this.appSortable, direction: this.direction });
  }
}
